<div class="p-4 rounded-xl">

  <div class="flex justify-between mb-4">
    <h2 class="text-lg font-semibold">{{ 'QUESTIONNAIRE.TITLE' | translate }}</h2>

    <button class="btn-primary" (click)="openPopup()">
      {{ 'QUESTIONNAIRE.ADD_BUTTON' | translate }}
    </button>
  </div>

  <app-table
    [columns]="columns"
    [data]="list"
    [actions]="actions"
  ></app-table>

  <app-popup
    [(show)]="showPopup"
    title="QUESTIONNAIRE.TITLE"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    [readonly]="isViewMode"
    type="form"
  ></app-popup>

  <app-popup
    [(show)]="showDeletePopup"
    title="QUESTIONNAIRE.DELETE_TITLE"
    type="confirm"
    message="QUESTIONNAIRE.DELETE_CONFIRM"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmDelete()"
  ></app-popup>

</div>